import styles from "./MessageBubbleContent.styles.scss";
import {MESSAGE_REMOVED_BY_MODERATOR} from "../../constants";
import ListItem from "../list-item";
import Icon from "../Icon/Icon";
import {humanFileSize} from "../../../utils";
import Avatar from "../avatar";
import {Body} from "../typography";

const MessageBubbleContent = ({message, onClickAttachment}) => {
  const attachmentSize = message.size ? String(humanFileSize(message.size)) : "";
  return <div className={[styles.content, message.hiddenByModerator && styles.contentFaded].join(" ")}>
    {message.hiddenByModerator && MESSAGE_REMOVED_BY_MODERATOR}
    {!message.hiddenByModerator && message.content}
    {!message.hiddenByModerator && message.type === "attachment" &&
      <ListItem download href={message.url} onClick={onClickAttachment} className={styles.attachment} fadedSubtitle left={<Avatar color="#78c67f"><Icon name="download" color="#dcf8c6" /></Avatar>} title={<Body size="body2" weight={600}>{message.filename}</Body>} subtitle={attachmentSize} />
    }
  </div>
};

export default MessageBubbleContent;



// WEBPACK FOOTER //
// ./components/MessageBubbleContent/MessageBubbleContent.js